module.exports = __webpack_public_path__ + "img/cooperation17.f48897e0.png";